module.exports = __webpack_public_path__ + "img/midwest-summer-1920x550.d3f2a72b.jpg";